import createTableStore from "ds/components/Table/store/useTableStore";

import {
  INTENT_PROJECT_ENVIRONMENT_VARIABLES_COLUMN_CONFIG,
  INTENT_PROJECT_ENVIRONMENT_VARIABLES_COLUMNS_STORAGE_KEY,
} from "./constants";

const useIntentProjectEnvironmentVariablesTableStore = createTableStore({
  storageKey: INTENT_PROJECT_ENVIRONMENT_VARIABLES_COLUMNS_STORAGE_KEY,
  config: INTENT_PROJECT_ENVIRONMENT_VARIABLES_COLUMN_CONFIG,
  version: 2,
});

export default useIntentProjectEnvironmentVariablesTableStore;
